import { render, staticRenderFns } from "./ControlsMetaBlock.vue?vue&type=template&id=05979a93"
import script from "./ControlsMetaBlock.vue?vue&type=script&lang=js"
export * from "./ControlsMetaBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports